import { EstadoUsuarioI } from "./estadoUsuario.intreface";
import { TipoUsuarioI } from "./tipoUsuario.interface";

export class UsuarioI{
  id : String;
  username : String;
  password : String;
  nombres : String;
  apellidos : String;
  tipoIdent : String;
  identificacion : String;
  fechaExpiracion : String;
  correo : String;
  telefono : String;
  extencion : String;
  cargo : String ;
  token : String;
  expiracionToken : String;
  nuevaClave : Boolean;
  tipoUsuario : TipoUsuarioI;
  estadoUsuario : EstadoUsuarioI;
  fuente : any;
}
